export enum OasisAddendumStatusEnum {
  NeedsResponse = 1,
  ResponseAccepted = 2,
  ResponseRejected = 3
}

export const OasisAddendumStatusOptions = [
{ id: 1, label: 'Needs Response' },
{ id: 2, label: 'Response Accepted' },
{ id: 3, label: 'Response Rejected' }
];
